import React from 'react';
import { useObserver } from '../../../CodesThatsGottaGoSomewhereElse';
import { Icon } from '../../../concepts/resources/Icon';
import { Notice } from '../../../ui/Notice';
import { useResolve, useResolveMaybe } from '../../Container';
import { ProfileModel } from '../../ProfileModel';
import { useOnTeamAddUserViaPopup } from '../../actions/WorkspaceActions';
import { WorkspaceModel } from '../../dashboard/Models';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { NavMenu } from './NavMenu';
import { WorkspaceSelector } from './WorkspaceSelector';

const WarningBlock = () => {

    const me = useObserver(useResolve(ProfileModel));
    const workspace = useObserver(useResolveMaybe(WorkspaceModel));
    const isInThisTeam = !!workspace?.members?.find(x => x.id === me.id);
    if (isInThisTeam) return null;

    return <Notice icon="exclamation">
        <span>You are not a member of this team!</span>
    </Notice>;
};

export const WorkspaceSelectorBlock = React.memo(() => {

    const activeWorkspace = useObserver(useResolve(WorkspaceModel));
    const { canTeamAddUser, onTeamAddUser } = useOnTeamAddUserViaPopup(activeWorkspace);

    return <>
        <WarningBlock />
        <Flexer flex="row" gap=".5">
            <Flexer grow>
                <WorkspaceSelector />
            </Flexer>
            {canTeamAddUser &&
                <Flexer flex="row" center>
                    <NavMenu.Item onClick={onTeamAddUser}>
                        <NavMenu.ItemIcon>
                            <Icon src="deqo://icons/dash/members-add" />
                        </NavMenu.ItemIcon>
                    </NavMenu.Item>
                </Flexer>
            }
        </Flexer>
    </>;
});

